$(document).ready(function () {

    var $libraryList = $('.library-list');
    var $selectedBranch;
    var schoolsFilterOn = true;
    var publicLibraryFilterOn = true;
    var detectionMethod = "none";
    var selectedRadius = 50;
    var selectedSort = $('#sortSelector').val();
    var searchOptions = {};
    var ariaLiveToggle = ".";
    
    var displayErrorMessage = function () {
        $(".no-libraries-found-container").show();
        $(".see-more-consortium").hide();
        $(".sort-container").hide();
        $libraryList.empty();
    }

    var buildLibrarySystem = function (data, hideConsortium) {

        var libraryType = "";
        if (data.isPublic) {
            libraryType = "public"
        } else if (data.isSchool) {
            libraryType = "school"
        }

        var html = `<div class="library-system ${libraryType} ${hideConsortium ? `hideConsortium` : ``}">
                        <div class="library-system-header">
                            ${data.consortiumLogo
                ? `<img src="${data.consortiumLogo}" class="consortiumLogo" alt="${data.consortiumName} logo" />`
                : `<span class="filter-icon filter-${libraryType}-icon"></span>`}

                            <h2 tabindex="0" aria-label="${data.consortiumName}" class="library-system__title">
                                ${data.consortiumName}
                            </h2>

                            ${window.OverDrive.isAuthenticated
                ? `<div tabindex="0" class="library-system__save library-button-container">
                                </div>`
                : ``}

                            ${data.geoJson.length > 3
                ? `<div class="see-all-link" data-id="${data.consortiumId}" active="false">${window.OverDrive.SiteCopy.get(
                    "librariesPage.seeAllBranches")}</div>`
                : ``}
                        </div>
                    </div>`;
        var system = $(html);

        system.find(".library-button-container").keypress((e) => {
            var keycode = (e.keyCode ? e.keyCode : e.which);
            if (keycode == '13') {
                e.preventDefault();
                var target = $(e.currentTarget);
                target.children("div")[0].click();
            }
        });

        return system.append(buildLibraryItems(data));
    };

    var buildLibraryItems = function (libraryData) {
        var list = $('<ul class="library-system__branches"></ul>');
        var data = libraryData.geoJson;

        for (i = 0; i < data.length; i = i + 1) {
            var item = data[i];

            var gacHtml = "";
            if (item.properties.isIdcEnabled) {
                let idcUrl;
                // neither of these options work properly.  Eventually we want to add support to Zelda for IDC links to clear this up.  Ask Lyle Hennicke about it.
                if (window.OverDrive.featureManager.isEnabled('use-zelda-links')) {
                    idcUrl = libraryData.consortiumUrl;
                } else {
                    idcUrl = libraryData.consortiumUrl + '/account/ozone/sign-in?forward=%2F&showIdcSignUp=true';
                }

                gacHtml = '<a class="gacLink" href="' + idcUrl +
                    '" aria-label="' +
                    window.OverDrive.SiteCopy.get("ariaLabels.getInstantCard",
                        { "libraryName": libraryData.consortiumName }) +
                    '" target="_blank" rel="noreferrer" class="cardLink"><img class="gacImg" src="/Content/img/icons/svg/holding-phone-icon.svg" alt="Get an Instant Card icon" /> ' +
                    window.OverDrive.SiteCopy.get("findInLibrariesPage.getInstantCard") +
                    '</a>';
            } else if (item.properties.branchCardAcquisitionUrl != "" &&
                item.properties.branchCardAcquisitionUrl != null) {
                gacHtml = '<a class="gacLink" href="' +
                    item.properties.branchCardAcquisitionUrl +
                    '" target="_blank" rel="noreferrer" aria-label="' +
                    window.OverDrive.SiteCopy.get("ariaLabels.getLibraryCard",
                        { "libraryName": libraryData.consortiumName }) +
                    '" class="cardLink needACard">' +
                    window.OverDrive.SiteCopy.get("findInLibrariesPage.needLibraryCard") +
                    '</a>';
            }

            list.append(`<li data-consortium-id="${libraryData.consortiumId}" 
                            ${i === 0 ? `style="border-top: 5px solid ${libraryData.consortiumColor}"` : ``}
                            class="${i > 2 ? `hideLibrary` : ``}"
                            data-branch-id="${item.properties.id}" 
                            data-has-location="${item.geometry.coordinates[0] !== 0 ||
                item.geometry.coordinates[0] !== 0}">
                            <div class="library-info">
                                <div class="library-name" tabindex="0" aria-label="${item.properties.title}">${item.properties.title}</div>
                                <div class="library-system__branch-location">
                                    ${item.properties.address ? item.properties.address : ``}, 
                                    ${item.properties.city ? item.properties.city : ``}, 
                                    ${item.properties.state ? item.properties.state : ``}, 
                                    ${item.properties.postalCode ? item.properties.postalCode : ``}
                                </div>
                                <div class="phone-number">${item.properties.phoneNumber ? item.properties.phoneNumber : ''}</div>
                            </div>
                            <div class="libray-links">
                                <a class="libraryLink" href="${libraryData.consortiumUrl}">
                                    <div class="libraryLinkDiv">${window.OverDrive.SiteCopy.get("librariesPage.seeDigitalCollection")}</div>
                                </a>
                                ${gacHtml}
                            </div>
                        </li>`);
        }

        return list;
    };

    var renderItems = function (data) {
        $(".no-libraries-found-container").hide();

        // remove the previously loaded items
        $libraryList.find('.library-system').remove();

        // iterate through each consortium in the data
        for (var i = 0; i < data.length; i++) {
            $libraryList.append(buildLibrarySystem(data[i], i > 2));

            // now that the template has been appended to the DOM we can bind
            // to the click event of each list item.

            var $system = $libraryList.children().last();

            var libraryButton = new OverDrive.LibraryButton({
                $container: $system,
                isSaved: data[i].consortiumIsSaved,
                consortiumId: data[i].consortiumId
            });
        }

        $(".see-all-link").on('click',
            (e) => {
                var target = $(e.target);
                var id = $(e.target).attr("data-id");

                if (target.attr("active") === "false") {
                    $('li[data-consortium-id="' + id + '"].hideLibrary').show();
                    target.attr("active", "true");
                    target.text(window.OverDrive.SiteCopy.get("librariesPage.seeLess"));
                } else {
                    $('li[data-consortium-id="' + id + '"].hideLibrary').hide();
                    target.attr("active", "false");
                    target.text(window.OverDrive.SiteCopy.get("librariesPage.seeAllBranches"));
                }
            });

        $(".see-more-consortium").toggle(data.length > 3);

        $(".sort-container").show();
    };

    var screenReaderMessage = function (message, elementToFocusBeforeLive, elementToHideBeforeLive) {
        // These timeout lengths seem to be the shortest for best consistency with results from JAWS on Firefox. Change with caution
        setTimeout(function () {
            if (elementToFocusBeforeLive) {
                elementToFocusBeforeLive.focus();
            }
            if (elementToHideBeforeLive) {
                elementToHideBeforeLive.hide();
            }
            setTimeout(function () {
                // This forces the screen reader to read the "new" content since it doesn't repeat messages if they are the same
                ariaLiveToggle = ariaLiveToggle === "." ? "" : ".";
                $(".sr-only")[0].innerHTML = `${message}${ariaLiveToggle}`;
            }, 100);
        }, 250);
    };

    $(".see-more-consortium").on('click',
        () => {
            let additionalConsortiums = 3;
            var newConsortiumsToShow = $(".hideConsortium").slice(0, additionalConsortiums).removeClass("hideConsortium");

            var consortiumPlurality = (newConsortiumsToShow.length - 1) === 1 ? "" : "s";
            var message = `and ${newConsortiumsToShow.length - 1} more consortium${consortiumPlurality} loaded`;
            var elementToFocusBeforeLive = $(newConsortiumsToShow[0]).find("h2")[0];
            var elementToHideBeforeLive = $(".hideConsortium").length === 0 ? $(".see-more-consortium") : undefined;
            screenReaderMessage(message, elementToFocusBeforeLive, elementToHideBeforeLive);
        });

    var getRandomColor = function () {
        // ensure that the random color will work with white text
        var rgb = [
            Math.random() * 0xFF << 0,
            Math.random() * 0xFF << 0,
            Math.random() * 0xFF << 0
        ];

        if (rgb[0] > 0x7f && rgb[1] > 0x7f && rgb[2] > 0x7f) {
            var randomIndex = Math.random() * 3 << 0;
            rgb[randomIndex] = rgb[randomIndex] / 2 << 0;
        }

        var color =
            ('00' + rgb[0].toString(16) + ' ').slice(-3, -1) +
            ('00' + rgb[1].toString(16) + ' ').slice(-3, -1) +
            ('00' + rgb[2].toString(16) + ' ').slice(-3, -1);

        return '#' + color;
    };

    var querySearch = function () {
        let query = $('input.query').val();
        let url = `/mapbox/find-libraries-by-query?query=${query}`;
        detectionMethod = "none";
        internalSearch(url);
    };

    var locationSearch = function (lat, long) {
        let url = `/mapbox/find-libraries-by-location?latLng=${positionToString(lat, long)}`;
        internalSearch(url, true);
    };

    var positionToString = function (lat, lng) {
        return lat + "," + lng;
    };

    var setupLocateMe = function () {
        var $locateMe = $('.map-tools__item[data-action="locate"]');

        if ($locateMe && $locateMe.length > 0) {
            $locateMe.on('click', (event) => {
                getUserLocation(function (lat, lng) {
                    locationSearch(lat, lng);
                });
                event.stopPropagation();
            }); 
        }
    };

    var getUserLocation = function (callback) {
        if (typeof callback !== 'function') {
            return;
        }

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                function (position) {
                    detectionMethod = "browser";
                    callback(position.coords.latitude, position.coords.longitude);
                },
                function () {
                    getUserLocationFromIp(callback);
                });
        }
        else {
            getUserLocationFromIp(callback);
        }
    };

    var getUserLocationFromIp = function (callback) {
        $.get('/mapbox/get-user-location-by-ip/?ip=' + window.OverDrive.testIp)
            .done(function (location) {
                if (location && location.isValid) {
                    detectionMethod = "ip";
                    callback(location.latitude, location.longitude);
                }
                else {
                    console.log('Invalid location detected');
                    displayErrorMessage('/mapbox/could-not-locate/');
                }
            })
            .fail(function () {
                console.log('Failed to get location from IP.');
                displayErrorMessage('/mapbox/could-not-locate/');
            });
    }

    var addSearchOptionsToUrl = function (url, locationSearch = false) {
        if (searchOptions.includePublicLibraries !== 'undefined' &&
            searchOptions.includeSchoolLibraries !== 'undefined') {
            url += `&includePublicLibraries=${!!searchOptions.includePublicLibraries}&includeSchoolLibraries=${!!searchOptions.includeSchoolLibraries}`;
        }

        if (searchOptions.sort !== 'undefined') {
            url += `&sort=${searchOptions.sort}`;
        }

        if (locationSearch) {
            url += `&radius=${selectedRadius}`;
        }

        if (detectionMethod !== "none") {
    
            url += `&detectionMethod=${detectionMethod}`;
        }

        return url;
    }

    var internalSearch = function (url, locationSearch = false) {
        var updatedUrl = addSearchOptionsToUrl(url, locationSearch);

        jqxhr = $.getJSON(updatedUrl)
        .done(function (data) {
            if (data.length === 0) {
                screenReaderMessage("Search completed with no libraries or schools found");
                displayErrorMessage('/mapbox/no-matches-found/');
                jqxhr = null;
                return;
            }
            
            var libraryPlurality = data.length === 1 ? "y" : "ies";
            var schoolPlurality = data.length === 1 ? "" : "s";
            screenReaderMessage(`Search completed with ${data.length} matching librar${libraryPlurality} or school${schoolPlurality} found`);
            for (var i = 0; i < data.length; i++) {
                data[i].consortiumColor = getRandomColor();
            }
            renderItems(data);
        });
    }

    var updateSearchOptions = function () {
        Object.assign(searchOptions, {
            includePublicLibraries: publicLibraryFilterOn,
            includeSchoolLibraries: schoolsFilterOn,
            radius: selectedRadius,
            sort: selectedSort
        });
    };

    var addEventHandlers = function () {

        $('.submit-search').on('click', () => {
            event.preventDefault();
            querySearch();
        });

        $(".public-filtering").keypress((e) => {
            var keycode = (e.keyCode ? e.keyCode : e.which);
            if (keycode == '13') {
                var target = $(e.currentTarget);
                target.click();
            }
        });

        $(".public-filtering").on("click", (e) => {
            var radioBtn = $(e.currentTarget).find(".radioBtn");
            var isChecked = radioBtn.hasClass("check");
            if (isChecked) {
                if (schoolsFilterOn) {
                    publicLibraryFilterOn = false;
                    radioBtn.removeClass("check");
                    radioBtn.attr("aria-checked", "false");
                }
            } else {
                publicLibraryFilterOn = true;
                radioBtn.addClass("check");
                radioBtn.attr("aria-checked", "true");
            }
            updateSearchOptions();
            querySearch();
         });

        $(".school-filtering").keypress((e) => {
            var keycode = (e.keyCode ? e.keyCode : e.which);
            if (keycode == '13') {
                var target = $(e.currentTarget);
                target.click();
            }
        });

        $(".school-filtering").on("click", (e) => {
            var radioBtn = $(e.currentTarget).find(".radioBtn");
            var isChecked = radioBtn.hasClass("check");
            if (isChecked) {
                if (publicLibraryFilterOn) {
                    schoolsFilterOn = false;
                    radioBtn.removeClass("check");
                    radioBtn.attr("aria-checked", "false");
                }
            } else {
                schoolsFilterOn = true;
                radioBtn.addClass("check");
                radioBtn.attr("aria-checked", "true");
            }
            updateSearchOptions();
            querySearch();
        });

        $(".mobile-filter-button").on('click', (e) => {
            e.preventDefault();
            e.stopImmediatePropagation();
            var target = $(e.target);

            if (target.attr("aria-expanded") === "false") {
                target.attr("aria-expanded", "true");
                target.css("background-image", 'url("/Content/img/search-filter-icon-open.svg")');
                $(".filteringContainer").removeClass("hide");
            } else {
                target.attr("aria-expanded", "false");
                target.css("background-image", 'url("/Content/img/search-filter-icon-closed.svg")');
                $(".filteringContainer").addClass("hide");
            }
        });

        $(".icon-location").on('click', (e) => {
            e.preventDefault();
            if (window.OverDrive.useIpLocation == true) {
                navigator.geolocation.getCurrentPosition(function (position) {
                    locationSearch(position.coords.latitude, position.coords.longitude);
                    $('.library-search-bar__locator').addClass("filled");
                },
                    function errorCallback(error) {
                        // Not doing anything here yet
                    });
            }
        });

        $("#radiusSelector").change((e) => {
            selectedRadius = $("#radiusSelector").val();
            updateSearchOptions();
            //querySearch();
        });

        $("#sortSelector").change((e) => {
            selectedSort = $("#sortSelector").val();
            updateSearchOptions();
            querySearch();
        });
    }

    var initializeTable = function (lat, long) {
        updateSearchOptions();
        addEventHandlers();
        setupLocateMe();

        if (window.OverDrive.query != "" && window.OverDrive.searchLibrariesByQuery) {
            $("#inlineLibraryFilter").val(window.OverDrive.query);
            querySearch();
        }
        else {
            locationSearch(lat, long);
        }
    }

    if (window.OverDrive.latitude != "" && window.OverDrive.longitude != "") {
        initializeTable(window.OverDrive.latitude, window.OverDrive.longitude);
    } else if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
            defaultLat = position.coords.latitude;
            defaultLng = position.coords.longitude;

            initializeTable(defaultLat, defaultLng);
            $('.library-search-bar__locator').addClass("filled");
        },
            function errorCallback(error) {
                if (error.code == error.PERMISSION_DENIED) {
                    initializeTable(40, -74.50); //default location
                }
            });
    } else {
        initializeTable(40, -74.50); //default location
    }
});